// extracted by mini-css-extract-plugin
export default {"container":"CpDKRZ","floatingText":"r6pYky"};